import { ITelegramAccountRepository, TelegramAccountListResult } from '../../ports/ITelegramAccountRepository';

export class ListTelegramAccountsUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(params: { page: number; perPage: number; search?: string }): Promise<TelegramAccountListResult> {
    return this.repo.list(params);
  }
}
